import { Injectable } from "@angular/core";

@Injectable()
export class UnitService {
  private _options = [
    {value: 1, label: '-'},
    {value: 2, label: '/ Sq. m.'},
    {value: 3, label: '/ Sq. ft'},
    {value: 4, label: '/ Piece'},
    {value: 5, label: '/ Set'},
    {value: 6, label: '/ m'},
    {value: 7, label: '/ m3'},
    {value: 8, label: '/ Tonne'},
    {value: 9, label: '%'},
    {value: 10, label: '/ Floor'},
    {value: 11, label: '/ Room'},
    {value: 12, label: '/ Unit'},
    {value: 13, label: '% Of Total Construction Costs, excluding groups 08, 10'},
    {value: 14, label: '% Of Total Construction Costs, excluding groups 08, 09, 10'},
    {value: 15, label: '% Of Total Construction Costs, excluding groups 09, 10'},
    {value: 16, label: '% Of Total Construction Costs, excluding groups 13'},
    {value: 17, label: '% Of Site acquisition costs'},
  ]

  getOptionFromSizeUnit(sizeUnitId: number): number {
    if (sizeUnitId === 1) return 2
    return 1
  }

  getOptions() {
    return this._options
  }
}